import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useIsMobile } from '@brg/ui';
import { DesignerMultipleAuthors, ProjectDesignerWrapper } from './styles';
import { ProjectDesignersTooltip } from './ProjectDesignersTooltip';
import { AupArrowSvg } from './assets/aup';
import useLocalization from "../../hooks/useLocalization";
/**
 *
 * **ProjectDesignerName** - принимает на вход одного дизайнера или массив.
 * Отображает "Дизайнер Имя" или "Несколько авторов" с тултипом, отображающим массив.
 * Шрифт подстраивается под высший размер.
 *
 * @param props
 */
export var ProjectDesignerName = function (_a) {
    var value = _a.value, _b = _a.multipleAuthorsFit, multipleAuthorsFit = _b === void 0 ? true : _b, navigationHandler = _a.navigationHandler;
    var fistDesigner = value[0];
    var _c = useState(true), isClosed = _c[0], setIsClosed = _c[1];
    var isMobile = useIsMobile();
    // @ts-ignore
    var t = useLocalization().t;
    var titleRef = useRef(null);
    var containerRef = useRef(null);
    var handleFirstDesignerCLick = useCallback(function (e, isMultiple) {
        e.preventDefault();
        e.stopPropagation();
        if (isMobile)
            setIsClosed(function (prev) { return !prev; });
        if (fistDesigner && !isMultiple) {
            if (typeof (navigationHandler) === 'function') {
                navigationHandler(e);
                return;
            }
            window.open('/designer/' + (fistDesigner === null || fistDesigner === void 0 ? void 0 : fistDesigner.accountId));
        }
    }, [fistDesigner, isMobile, isClosed]);
    var onClickDocument = function (event) {
        var _a, _b;
        if (isClosed || ((_a = titleRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)) || ((_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.contains(event.target)))
            return;
        setIsClosed(true);
    };
    useEffect(function () {
        if (value.length <= 1 || !isMobile)
            return;
        document.addEventListener('mousedown', onClickDocument);
        document.addEventListener('touchstart', onClickDocument);
        return function () {
            document.removeEventListener('mousedown', onClickDocument);
            document.removeEventListener('touchstart', onClickDocument);
        };
    }, [onClickDocument, isMobile, value.length]);
    // Если дизайнеров нет, возвращает пустой фрагмент
    if (value.length < 1) {
        return null;
    }
    if (value.length === 1) {
        // Если дизайнер один - отобразить его имя
        return (React.createElement("div", { className: 'single_designer_wrapper', onClick: handleFirstDesignerCLick },
            React.createElement(ProjectDesignerWrapper, null, fistDesigner.name + ' ' + fistDesigner.surName)));
    }
    return (
    // Если дизайнеров много - вывести сообщение об этом и подключить тултип
    React.createElement("div", null,
        React.createElement(ProjectDesignersTooltip, { offset: [-150, 5], containerRef: containerRef, 
            // onHide={() => setIsClosed(true)}
            // onShow={() => setIsClosed(false)}
            visible: isMobile ? !isClosed : undefined, hideOnClick: false, target: React.createElement(DesignerMultipleAuthors, { ref: titleRef, active: !isClosed, big: !multipleAuthorsFit, className: 'white_theme_designer_wrapper', onClick: function (e) { return handleFirstDesignerCLick(e, true); }, gx: 6 },
                React.createElement("div", null, t("multiple_authors")),
                React.createElement(AupArrowSvg, { isClosed: isClosed })), items: isMobile && isClosed ? [] : value, theming: {
                color: '#FEFEFE'
            } })));
};
//# sourceMappingURL=projectDesignerName.js.mapimport React, { useCallback, useEffect, useRef, useState } from 'react';
import { useIsMobile } from '@brg/ui';
import { DesignerMultipleAuthors, ProjectDesignerWrapper } from './styles';
import { ProjectDesignersTooltip } from './ProjectDesignersTooltip';
import { AupArrowSvg } from './assets/aup';
import useLocalization from "../../hooks/useLocalization";
/**
 *
 * **ProjectDesignerName** - принимает на вход одного дизайнера или массив.
 * Отображает "Дизайнер Имя" или "Несколько авторов" с тултипом, отображающим массив.
 * Шрифт подстраивается под высший размер.
 *
 * @param props
 */
export var ProjectDesignerName = function (_a) {
    var value = _a.value, _b = _a.multipleAuthorsFit, multipleAuthorsFit = _b === void 0 ? true : _b, navigationHandler = _a.navigationHandler;
    var fistDesigner = value[0];
    var _c = useState(true), isClosed = _c[0], setIsClosed = _c[1];
    var isMobile = useIsMobile();
    // @ts-ignore
    var t = useLocalization().t;
    var titleRef = useRef(null);
    var containerRef = useRef(null);
    var handleFirstDesignerCLick = useCallback(function (e, isMultiple) {
        e.preventDefault();
        e.stopPropagation();
        if (isMobile)
            setIsClosed(function (prev) { return !prev; });
        if (fistDesigner && !isMultiple) {
            if (typeof (navigationHandler) === 'function') {
                navigationHandler(e);
                return;
            }
            window.open('/designer/' + (fistDesigner === null || fistDesigner === void 0 ? void 0 : fistDesigner.accountId));
        }
    }, [fistDesigner, isMobile, isClosed]);
    var onClickDocument = function (event) {
        var _a, _b;
        if (isClosed || ((_a = titleRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)) || ((_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.contains(event.target)))
            return;
        setIsClosed(true);
    };
    useEffect(function () {
        if (value.length <= 1 || !isMobile)
            return;
        document.addEventListener('mousedown', onClickDocument);
        document.addEventListener('touchstart', onClickDocument);
        return function () {
            document.removeEventListener('mousedown', onClickDocument);
            document.removeEventListener('touchstart', onClickDocument);
        };
    }, [onClickDocument, isMobile, value.length]);
    // Если дизайнеров нет, возвращает пустой фрагмент
    if (value.length < 1) {
        return null;
    }
    if (value.length === 1) {
        // Если дизайнер один - отобразить его имя
        return (React.createElement("div", { className: 'single_designer_wrapper', onClick: handleFirstDesignerCLick },
            React.createElement(ProjectDesignerWrapper, null, fistDesigner.name + ' ' + fistDesigner.surName)));
    }
    return (
    // Если дизайнеров много - вывести сообщение об этом и подключить тултип
    React.createElement("div", null,
        React.createElement(ProjectDesignersTooltip, { offset: [-150, 5], containerRef: containerRef, 
            // onHide={() => setIsClosed(true)}
            // onShow={() => setIsClosed(false)}
            visible: isMobile ? !isClosed : undefined, hideOnClick: false, target: React.createElement(DesignerMultipleAuthors, { ref: titleRef, active: !isClosed, big: !multipleAuthorsFit, className: 'white_theme_designer_wrapper', onClick: function (e) { return handleFirstDesignerCLick(e, true); }, gx: 6 },
                React.createElement("div", null, t("multiple_authors")),
                React.createElement(AupArrowSvg, { isClosed: isClosed })), items: isMobile && isClosed ? [] : value, theming: {
                color: '#FEFEFE'
            } })));
};
//# sourceMappingURL=projectDesignerName.js.map